:host {
  display: block;
  outline: none;
}

:host * {
  font-family: var(--dc-font-family);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.2px;
}

.dc-time-picker {
  position: relative;
  background-color: var(--dc-background-token-fill-color);
  color: var(--dc-primary-text-color);
  min-width: 272px;
  max-width: 400px;
}

.dc-time-picker-clear,
.dc-time-picker-clock {
  position: absolute;
  top: 15px;
  right: 16px;
  cursor: pointer;
  outline: none;
  border: none;
  background: transparent;
  color: var(--dc-primary-text-color);
  padding: 0;
  display: inline-flex;
}

.dc-time-picker-clear:focus-visible {
  outline: 2px solid var(--dc-primary-colour);
  outline-offset: 1px;
  border-radius: 10px;
}

.dc-time-picker-clear-icon,
.dc-time-picker-clock-icon {
  width: 20px;
  height: 20px;
}

.dc-time-picker-clear-icon path {
  fill: var(--dc-primary-interactive-color);
}

.dc-time-picker-clock-icon path {
  fill: var(--dc-accent-text-color);
}

.dc-time-picker-label {
  position: absolute;
  top: 14px;
  left: 12px;
  padding: 0 4px;
  background: var(--dc-background-token-fill-color);
  color: var(--dc-primary-text-color);
  transition: all 0.3s;
  max-width: calc(100% - 52px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: text;
}

.dc-time-picker-input {
  height: 52px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  outline: 3px solid transparent;
  border: 1px solid var(--dc-token-border-default-01);
  border-radius: 8px;
  position: relative;
}

.dc-time-picker-input-content {
  height: 100%;
  display: flex;
  padding: 14px 16px;
  cursor: text;
  border-radius: 8px;
}

.dc-time-picker-control {
  display: none;
  width: 100%;
  position: relative;
}

.dc-time-picker-control-content {
  background-color: var(--dc-background-token-fill-color);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border: 2px solid var(--dc-primary-colour);
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 10;
}

.dc-time-picker-control-content input {
  background-color: var(--dc-background-token-fill-color);
  color: var(--dc-primary-text-color);
  border: none;
  caret-color: var(--dc-primary-colour);
  box-sizing: border-box;
  height: 50px;
  width: 100%;
  outline: none;
  padding: 13px 15px 14px 15px;
  text-overflow: ellipsis;
}

.dc-time-picker-control-content input::placeholder {
  color: var(--dc-accent-text-color);
}

.dc-time-picker-time-control-container {
  display: flex;
  align-self: stretch;
  height: 248px;
  overflow: hidden;
  border-width: 1px 0;
  border-style: solid;
  border-color: var(--dc-token-border-default-01);
}

.dc-time-picker-confirm-container {
  display: flex;
  justify-content: end;
  padding: 24px 16px
}

.dc-time-picker-time-control-container .dc-time-picker-time-option {
  cursor: pointer;
  border: none;
  padding: 12px 16px;
  line-height: 24px;
  border-radius: 8px;
  height: 48px;
  width: 56px;
  outline: none;
  background: transparent;
  color: var(--dc-primary-text-color);
}

.dc-time-picker-time-control-container .dc-time-picker-option-active {
  background: var(--dc-primary-colour);
  color: var(--dc-primary-text-interactive-color);
}

.dc-time-picker-divider {
  border-right: 1px solid var(--dc-token-border-default-01);
}

.dc-time-picker-options-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  overflow-y: auto;
  overflow-x: hidden;
}

.dc-time-picker-options-wrapper::-webkit-scrollbar {
  display: none;
}

.dc-time-picker-input-hidden {
  visibility: hidden;
  height: 0;
  padding: 0;
  margin: 0;
}

/* Hover state */
.dc-time-picker:not(.dc-time-picker-open):not(.dc-time-picker-disabled) .dc-time-picker-input:hover {
  border: 1px solid var(--dc-primary-accent-colour);
}

.dc-time-picker-time-control-container .dc-time-picker-time-option:not(.dc-time-picker-option-active):hover {
  background: var(--dc-token-interactive-hover-03);
  color: var(--dc-token-interactive-04);
}

/* Focus state */
.dc-time-picker:not(.dc-time-picker-open) .dc-time-picker-input:focus-visible {
  outline: 3px solid var(--dc-primary-colour);
  outline-offset: 1px;
}

.dc-time-picker-time-control-container .dc-time-picker-time-option:focus-visible {
  outline: 2px solid var(--dc-primary-colour);
  outline-offset: 1px;
}

/* Change state */
.dc-time-picker-changed .dc-time-picker-label {
  font-size: 12px;
  top: -6px;
  line-height: 16px;
}

/* Open state */
.dc-time-picker-open .dc-time-picker-label {
  font-size: 12px;
  top: -5px;
  left: 13px;
  line-height: 16px;
  z-index: 20;
}

.dc-time-picker-open .dc-time-picker-clear,
.dc-time-picker-open .dc-time-picker-clock {
  top: 16px;
  right: 17px;
  z-index: 20;
}

.dc-time-picker-open .dc-time-picker-control {
  display: block;
}

.dc-time-picker-open .dc-time-picker-input .dc-time-picker-label,
.dc-time-picker-open .dc-time-picker-input .dc-time-picker-clear,
.dc-time-picker-open .dc-time-picker-input .dc-time-picker-clock {
  display: none;
}

/* Disabled state */
.dc-time-picker-disabled .dc-time-picker-control {
  display: none;
}

.dc-time-picker-disabled .dc-time-picker-clear-icon {
  cursor: not-allowed;
}

.dc-time-picker-disabled .dc-time-picker-clock-icon {
  cursor: not-allowed;
}

.dc-time-picker-disabled .dc-time-picker-clear-icon path,
.dc-time-picker-disabled .dc-time-picker-clock-icon path {
  fill: var(--dc-token-disabled-01);
}

.dc-time-picker-disabled .dc-time-picker-input {
  border-color: var(--dc-ui-disabled-border);
  color: var(--dc-greyscale-04);
  cursor: not-allowed;
}

.dc-time-picker-disabled .dc-time-picker-label,
.dc-time-picker-disabled .dc-time-picker-value {
  color: var(--dc-greyscale-04);
  cursor: not-allowed;
}

.dc-time-picker-disabled .dc-time-picker-input:hover {
  border-color: var(--dc-ui-disabled-border);
}

.dc-time-picker-disabled .dc-time-picker-input:focus-visible {
  outline: none;
}

/* Error state */
.dc-time-picker-error-msg {
  display: none;
  color: var(--dc-primary-error-color);
  font-size: 12px;
  padding: 4px 0 0 14px;
  white-space: pre-wrap;
  margin: 0;
  outline: none;
}

.dc-time-picker-error .dc-time-picker-input {
  border: 1px solid var(--dc-primary-error-color);
}

.dc-time-picker-error .dc-time-picker-error-msg:not(:empty) {
  display: block;
}